define('components/VendorFilter/VendorFilterComponent',[
	'jquery',
	'core/can',
	'models/Session',
	'text!components/VendorFilter/VendorFilterView.stache',
	'bloodhound',
	'typeahead'
], function($, can, Session, template, Bloodhound) {
	
	function makeUpdateId(o) {
		// @param id
		// update display with name from model with id, 
		//  or with defined allText if id blank
		// update bound attribute with id,
		//  or clear it if id blank
		// update cached value in Session to persist across views
		return function(id) {
			
			var m = this.attr('map');
			
			this.attr(o.attrSelected, id
				? this.attr(o.attrList).findById(id).attr('Name')
				: o.allText);
			
			if (m) m.attr(o.attrBound, id
				? id
				: undefined);
			
			Session.attr('filter'+o.attrBound, id);
		}
	}
	
	var allAccounts = 'All Accounts',
		allProviders = 'All Providers',		
		large = 15,		
		Scope = can.Map.extend({
		
			selectedAccount: allAccounts,
			selectedProvider: allProviders,
			
			isAccountSelected: can.compute(function() {
				return this.attr('selectedAccount') !== allAccounts;	
			}),
			
			// Provider List for Selected Account
			AccountProviders: can.compute(function() {
				var id = this.attr('map.AccountId');
				return this.attr('Providers').filter(function(p) {
					return p.attr('AccountId') === id;
				});
			}),
			
			hasMultipleProviders: can.compute(function() {
				return this.attr('AccountProviders').attr('length') > 1;
			}),
			
			largeAccountList: can.compute(function() {
				return this.attr('Accounts.length') > large;
			}),
			
			largeProviderList: can.compute(function() {
				return this.attr('Providers.length') > large;
			}),
			
			updateAccountId: (function() {
				
				var updateId = makeUpdateId({
					attrSelected: 'selectedAccount',
					attrBound: 'AccountId',
					attrList: 'Accounts',
					allText: allAccounts,
				});
				
				return function(id) {
					updateId.call(this, id);
					this.updateProviderId(
						this.attr('AccountProviders').attr('length') === 1 
							? this.attr('AccountProviders.0').attr('_id')
							: undefined);
				}
			})(),
			
			updateProviderId: makeUpdateId({
				attrSelected: 'selectedProvider',
				attrBound: 'ProviderId',
				attrList: 'Providers',
				allText: allProviders,
			}),
			
			initTypeahead: function(scope, el) {
				
				if (el.hasClass('vf-large')) {
					
					// Bloodhound and Typeahead
					var engine = new Bloodhound({
						datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Name'),
						queryTokenizer: Bloodhound.tokenizers.whitespace,
						local: el.hasClass('vf-accounts')
							? scope.attr('Accounts').attr()
							: scope.attr('AccountProviders').attr(),
						limit: 10
					});
					engine.initialize().done(function() {
						el.find('input').typeahead(
							{ highlight: true, hint: false, limit: 15 },
							{ displayKey: 'Name', source: engine.ttAdapter() }
						);
					});
					
					var menu = el.find('.dropdown-menu'),
						tt = el.find('.tt-input'),
						doc = $(document),
						
						// close - click anywhere else
						handler = function(e) {
							if (!$.contains(el.get(0), e.target)) {
								menu.hide();
								doc.off('click', handler);
							}
						};
					
					// open - click toggle
					el.on('click', '.dropdown-toggle', function() {
						menu.show();
						tt.focus();
						doc.on('click', handler); // Bind close handler
					});
				}
			}
		});
	
	can.Component.extend({
		
		tag: 'vendor-filter',
		
		template: template,
		
		scope: function(attrs, parentScope, el) {
			
			var scope = new Scope({
					'map': attrs.map,
					'Accounts': Session.attr('Accounts'),
					'Providers': Session.attr('Providers'),
					'showProviders': attrs.showProviders
				}),
				aid = attrs.map.attr('AccountId'),
				pid = attrs.map.attr('ProviderId');
			
			if (pid && !aid) {
				aid = scope.attr('Providers').filter(function(p) {
					return p.attr('_id') === pid;
				}).attr('0.AccountId');
			}
			
			if (aid) scope.updateAccountId(aid);
			if (pid) scope.updateProviderId(pid);
			
			return scope;
		},

		events: {
			'.vf-accounts .dropdown-menu a click': function(el, ev) {
				var id = el.data('id');
				this.scope.updateAccountId(id);
			},
			'.vf-providers .dropdown-menu a click': function(el, ev) {
				var id = el.data('id');
				this.scope.updateProviderId(id);
			},
			'.vf-accounts typeahead:selected': function(el, ev, datum, dataset) {
				this.scope.updateAccountId(datum.EntityId);
				el.find('.dropdown-menu').hide().find('input').typeahead('val', '');
			},
			'.vf-providers typeahead:selected': function(el, ev, datum, dataset) {
				this.scope.updateProviderId(datum.EntityId);
				el.find('.dropdown-menu').hide().find('input').typeahead('val', '');
			}/*,
			'.dropdown-menu li:first-child a click': function(el, ev) {
				el.closest('.dropdown').find('.dropdown-menu').hide();
			}*/
		}
	});
	
});
